import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import _ from 'lodash';
import socket from '../../../../context/socket';
import YearSelect from '../../StartedYear/year';
import { useDispatch } from 'react-redux';
import { fetchClientData } from '../../../../redux/client/clientSlice';
import api from '../../../../utils/api';

// Debounce function to delay API calls
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

const VacationData = ({ roomId, card_id, planYourGoals }) => {
  const dispatch = useDispatch();

  const [selectedCard, setSelectedCard] = useState(null);
  const [vacationData, setVacationData] = useState({
    goalYear: "",
    amount: "",
    startYear: new Date().getFullYear().toString(),
  });

  // Fetch the selected card and set the initial data
  useEffect(() => {
    if (!planYourGoals || !card_id) return;

    const card = planYourGoals.find((item) => item._id === card_id);
    setSelectedCard(card);

    if (card?.action_data?.[0]) {
      const {
        goalYear = "",
        amount = "",
        startYear = new Date().getFullYear().toString(), // fallback
      } = card.action_data[0];

      setVacationData({
        goalYear,
        amount,
        startYear,
      });
    } else {
      // fallback if action_data doesn't exist
      setVacationData((prev) => ({
        ...prev,
        startYear: new Date().getFullYear().toString(),
      }));
    }
  }, [planYourGoals, card_id]);


  // Function to save data via API
  const saveData = async (updatedData) => {
    console.log("updatedData", updatedData);
    const allFieldsFilled =
      updatedData.amount !== "" &&
      updatedData.goalYear !== "" &&
      updatedData.startYear !== "";

    // Add the status field to the data
    // const dataWithStatus = {
    //   ...updatedData,
    //   status: allFieldsFilled ? 1 : 0, // Status is 1 if all fields are filled, otherwise 0
    // };
    
    const newStatus = allFieldsFilled ? 1 : 0;
    const prevCreatedAt = selectedCard?.created_at;

    const dataWithStatus = {
      ...updatedData,
      status: newStatus,
    };

    const payload = {
      _id: roomId,
      dream_id: card_id,
      action_data: [dataWithStatus],
      status: newStatus,
    };

    // ✅ Add created_at ONLY ONCE at ROOT
    if (newStatus === 1 && !prevCreatedAt) {
      payload.created_at = new Date().toISOString();
    }


    try {
      // Add status to each object in updatedData based on whether all fields are filled
      // const updatedWithStatus = [updatedData].map((item) => {
      //   const allFieldsFilled = Object.values(item).every((value) => value !== "");
      //   return { ...item, status: allFieldsFilled ? 1 : 0 };
      // });

      const response = await api.post(`advisor/save_goal_data`, payload);

      dispatch(fetchClientData(roomId));

      console.log("Data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };



  // Debounced save function
  const debouncedSaveData = useCallback(
    debounce((updatedData) => saveData(updatedData), 500),
    [selectedCard]
  );

  // Handle input changes
  const handleVacationInputChange = (field, value) => {
    const updatedData = {
      ...vacationData,
      [field]: value,
    };
    setVacationData(updatedData);

    // Trigger the debounced save function
    debouncedSaveData(updatedData);
  };


  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("emitted data", selectedCard, vacationData,);
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          vacationData,
        },
      });
    }, 300),
    [
      selectedCard,
      roomId,
      vacationData,
    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCard,
    debouncedEmitMessage,
    vacationData,
  ]);
  return (
    <>
      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I’m planning a vacation with my family in the year{" "}
            <input
              type="number"
              style={{
                border: "none",
                borderBottom: "1px solid green",
                width: `${vacationData.goalYear?.length + 3}ch`,
                paddingLeft: "1rem",
                minWidth: "7ch",
              }}
              value={vacationData.goalYear}
              // onChange={(e) =>
              //   handleVacationInputChange("goalYear", e.target.value)
              // }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (/^\d{0,4}$/.test(value) && Number(value) >= 0)) {
                  handleVacationInputChange("goalYear", value)
                }
              }}
              className="clrgreen fw-bold ps-3 moinput"
              placeholder="Year"
            />
          </p>
        </div>
      </div>

      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I expect this holiday to cost{" "}
            <span className="clrgreen fw-semibold">
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${vacationData.amount?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "7ch",
                }}
                value={vacationData.amount}
                // onChange={(e) =>
                //   handleVacationInputChange("amount", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleVacationInputChange("amount", value)
                  }
                }}
                className="clrgreen fw-bold ps-3 moinput"
                placeholder="0"
              />
            </span>
          </p>
        </div>
      </div>

      {/* <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            Start Year{" "}
            <span className="clrgreen fw-semibold">
              <select
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${vacationData.startYear?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "8ch",
                }}
                value={vacationData.startYear}
                onChange={(e) =>
                  handleVacationInputChange("startYear", e.target.value)
                }
                className="clrgreen fw-bold ps-3 moinput"
              >
                <option value="">Select</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </select>
            </span>
          </p>
        </div>
      </div> */}

      <div className="row ps-3 align-items-center">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>

        <div className="col-md-9 col-10 d-flex align-items-center">
          <p className="fs-21 lh-sm me-2 pt-3">Start Year:</p>
          <div style={{ minWidth: "120px" }}>
            <YearSelect
              value={vacationData.startYear}
              onChange={(val) => handleVacationInputChange("startYear", val)}
              recentYear={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default VacationData;
